/* eslint-disable react/forbid-prop-types */
/* eslint-disable max-classes-per-file */
import React, { Component, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import history from '../../../history';
import { serviceTypes } from '../../../consts';
import { getDisplayName } from '../../../utils';

const withPushFiltersToUrl = WrappedComponent =>
    class PushFiltersToUrl extends Component {
        setTable = table => {
            this.table = table;
        };

        paramsCleanUp = currentUrlParams => {
            // Make sure role and vehicle match's services
            if (
                currentUrlParams.get('service') === serviceTypes.CONSTRUCTION
            ) {
                currentUrlParams.delete('vehicle_type');
                currentUrlParams.delete('role');
                currentUrlParams.delete('industry_role');
            } else if (
                currentUrlParams.get('service') === serviceTypes.DRIVER
            ) {
                currentUrlParams.delete('construction_role');
                currentUrlParams.delete('role');
                currentUrlParams.delete('industry_role');
            } else if (
                currentUrlParams.get('service') === serviceTypes.HOSPITALITY
            ) {
                currentUrlParams.delete('construction_role');
                currentUrlParams.delete('vehicle_type');
                currentUrlParams.delete('industry_role');
            } else if (
                currentUrlParams.get('service') === serviceTypes.INDUSTRY
            ) {
                currentUrlParams.delete('construction_role');
                currentUrlParams.delete('vehicle_type');
                currentUrlParams.delete('role');
            } else {
                currentUrlParams.delete('construction_role');
                currentUrlParams.delete('vehicle_type');
                currentUrlParams.delete('role');
                currentUrlParams.delete('industry_role');
            }

            if (
                currentUrlParams.get('before') === 'all' &&
                currentUrlParams.get('after') === 'all'
            ) {
                currentUrlParams.set('getall', 1);
                currentUrlParams.delete('after');
                currentUrlParams.delete('before');
            } else if (
                currentUrlParams.get('before') &&
                currentUrlParams.get('after')
            ) {
                currentUrlParams.delete('getall', 1);
            }

            if (
                currentUrlParams.has('bookings_before') &&
                currentUrlParams.has('bookings_after')
            ) {
                if (currentUrlParams.get('bookings_before') === 'all') {
                    currentUrlParams.set('getall', 1);
                    currentUrlParams.delete('bookings_before');
                } else {
                    currentUrlParams.delete('getall', 1);
                }
            }

            if (
                currentUrlParams.get('search') &&
                currentUrlParams.get('search').match(/^(JR|BK)\d+/i)
            ) {
                currentUrlParams.set('getall', 1);
                currentUrlParams.delete('after');
                currentUrlParams.delete('before');
            }

            if (currentUrlParams.get('series')) {
                currentUrlParams.set('getall', 1);
                currentUrlParams.delete('after');
                currentUrlParams.delete('before');
            }
        };

        pushSortingToParamter = newSorted => {
            const currentUrlParams = new URLSearchParams(
                history.location.search,
            );

            newSorted.forEach(sort => {
                currentUrlParams.set(
                    'ordering',
                    `${sort.desc ? '' : '-'}${sort.id}`,
                );
            });
            history.push(`?${currentUrlParams.toString()}`);

            return currentUrlParams;
        };

        pushFiltersToParamter = filters => {
            const currentUrlParams = new URLSearchParams(
                history.location.search,
            );

            if (filters.hasOwnProperty('amount_status')) {
                switch (filters.amount_status) {
                    case 'TP':
                        filters.total_pay_gte = 0.01;
                        currentUrlParams.delete('total_pay_lte');
                        break;
                    case 'TP100':
                        filters.total_pay_gte = 100;
                        currentUrlParams.delete('total_pay_lte');
                        break;
                    case 'RF':
                        filters.total_pay_lte = -0.01;
                        currentUrlParams.delete('total_pay_gte');
                        break;
                    case 'AS':
                        filters.total_pay_gte = '0';
                        filters.total_pay_lte = '0';
                        break;
                    default:
                        currentUrlParams.delete('total_pay_gte');
                        currentUrlParams.delete('total_pay_lte');
                }
            }

            if (filters.hasOwnProperty('worker_status')) {
                switch (filters.worker_status) {
                    case 'published':
                        filters.published = '1';
                        filters.is_active = '1';
                        break;
                    case 'unpublished':
                        filters.published = '0';
                        filters.is_active = '1';
                        break;
                    case 'inactive':
                        filters.is_active = '0';
                        currentUrlParams.delete('published');
                        break;
                    default:
                        currentUrlParams.delete('is_active');
                        currentUrlParams.delete('published');
                }
            }

            if (filters) {
                const buildQuery = filterObj => {
                    Object.keys(filterObj).forEach(key => {
                        if (filterObj[key]) {
                            currentUrlParams.set(key, filterObj[key]);
                        } else {
                            currentUrlParams.delete(key);
                        }
                    });
                };

                if (filters === Object(filters)) {
                    buildQuery(filters);
                } else {
                    filters.map(filter => buildQuery(filter));
                }
            }

            if (filters.hasOwnProperty('series')) {
                // This prevents user from choosing different dates from Calendar when Series filter is defined
                currentUrlParams.set('getall', 1);
                currentUrlParams.delete('after');
                currentUrlParams.delete('before');
            }

            currentUrlParams.set('page', 1);
            this.paramsCleanUp(currentUrlParams);
            history.push(`?${currentUrlParams.toString()}`);

            return currentUrlParams;
        };

        onPageChange = pageIndex => {
            const currentUrlParams = new URLSearchParams(
                history.location.search,
            );

            if (pageIndex >= 1) {
                currentUrlParams.set('page', pageIndex ? pageIndex + 1 : 1);
            } else {
                currentUrlParams.delete('page');
            }

            history.push(`?${currentUrlParams.toString()}`);
        };

        onSortedChange = newSorted => {
            this.pushSortingToParamter(newSorted);
        };

        onFilterChange = (id, value) => {
            if (value.hasOwnProperty('value')) {
                const filter = {};
                filter[id] = value.value;
                this.pushFiltersToParamter(filter);
            } else {
                // Condition used for calendar date range only
                this.pushFiltersToParamter(value);
            }
        };

        getCurrentPage = () => {
            const currentUrlParams = new URLSearchParams(
                history.location.search,
            );

            if (currentUrlParams.get('page')) {
                return currentUrlParams.get('page') - 1;
            }

            return 0;
        };

        render() {
            return (
                <WrappedComponent
                    {...this.props}
                    onFilterChange={this.onFilterChange}
                    pushFiltersToParamter={this.pushFiltersToParamter}
                    setTable={this.setTable}
                    onPageChange={this.onPageChange}
                    onSortedChange={this.onSortedChange}
                    currentPage={this.getCurrentPage()}
                />
            );
        }
    };

const withRefreshTableOnFilterChange = WrappedComponent => {
    class RefreshTableOnParamsChange extends Component {
        componentDidUpdate(prevProps) {
            if (
                prevProps.location?.pathname ===
                    this.props.location?.pathname &&
                prevProps.location?.search !== this.props.location?.search
            ) {
                // eslint-disable-next-line react/prop-types
                this.props.load(new URLSearchParams(history.location.search));
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    }
    RefreshTableOnParamsChange.propTypes = {
        history: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        load: PropTypes.func.isRequired,
    };
    return RefreshTableOnParamsChange;
};

const withPutUrlSearchFiltersToProps = WrappedComponent => {
    const NewWrappedComponent = props => {
        const currentUrlParams = new URLSearchParams(history.location.search);
        const [searchValue, setSearchValue] = useState('');
        const [seriesValue, setSeriesValue] = useState('');

        useEffect(() => {
            setSearchValue(currentUrlParams.get('search') ?? '');
            setSeriesValue(currentUrlParams.get('series') ?? '');
        }, [currentUrlParams]);

        return (
            <WrappedComponent
                {...props}
                searchValue={searchValue}
                seriesValue={seriesValue}
            />
        );
    };

    NewWrappedComponent.displayName = `withPutUrlSearchFiltersToProps(${getDisplayName(
        WrappedComponent,
    )})`;

    return NewWrappedComponent;
};

export {
    withPushFiltersToUrl,
    withRefreshTableOnFilterChange,
    withPutUrlSearchFiltersToProps,
};
